import { useEffect } from 'react';
import { getInstitution } from '../config/institutionConfig';

/**
 * Hook que inyecta los CSS custom properties de la institución en :root.
 * Debe llamarse una sola vez, en el componente raíz (App).
 */
export const useInstitutionTheme = () => {
  const institution = getInstitution();

  useEffect(() => {
    const root = document.documentElement;
    const c = institution.colors;

    // Colores principales
    root.style.setProperty('--color-primary', c.primary);
    root.style.setProperty('--color-primary-dark', c.primaryDark);
    root.style.setProperty('--color-primary-light', c.primaryLight);

    // Gradiente del header
    root.style.setProperty('--header-gradient-start', c.headerGradientStart);
    root.style.setProperty('--header-gradient-mid', c.headerGradientMid);
    root.style.setProperty('--header-gradient-end', c.headerGradientEnd);
    root.style.setProperty('--header-border', c.headerBorder);
    root.style.setProperty('--header-shadow-primary', c.headerShadowPrimary);
    root.style.setProperty('--header-shadow-secondary', c.headerShadowSecondary);

    // Dark mode del header
    root.style.setProperty('--header-dark-gradient-start', c.headerDarkGradientStart);
    root.style.setProperty('--header-dark-gradient-mid', c.headerDarkGradientMid);
    root.style.setProperty('--header-dark-gradient-end', c.headerDarkGradientEnd);
    root.style.setProperty('--header-dark-border', c.headerDarkBorder);

    // Data attribute para selectores CSS
    document.body.setAttribute('data-institution', institution.id);

    // Título de la página
    document.title = institution.pageTitle;

    // Meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', institution.description);
    }
  }, [institution]);

  return institution;
};

export default useInstitutionTheme;
